import AdminTransactionDetailsLayout from "@Organism/Admin/Transaction/Details";

export default function AdminTransactionDetailsPage() {

  return (
    <AdminTransactionDetailsLayout />
  )
}